var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_64_16371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36C27.9411 36 36 27.9411 36 18Z",
    fill: "#7C7F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0957 10.7543H9.90416C9.62865 10.7544 9.35732 10.8217 9.11366 10.9503C8.87001 11.0789 8.66139 11.265 8.50586 11.4924L16.6008 17.2322C17.0098 17.5213 17.4983 17.6765 17.9991 17.6765C18.4999 17.6765 18.9884 17.5213 19.3974 17.2322L27.4915 11.4924C27.3362 11.2653 27.1279 11.0795 26.8848 10.9509C26.6416 10.8223 26.3708 10.7548 26.0957 10.7543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.098 18.2186C19.4844 18.6531 18.7511 18.8864 17.9992 18.8864C17.2474 18.8864 16.5141 18.6531 15.9005 18.2186L8.20898 12.7653V23.55C8.20898 23.9995 8.38756 24.4306 8.70541 24.7485C9.02327 25.0664 9.45438 25.2449 9.9039 25.2449H26.0954C26.5449 25.2449 26.9761 25.0664 27.2939 24.7485C27.6118 24.4306 27.7903 23.9995 27.7903 23.55V12.7653L20.098 18.2186Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_64_16371"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.7abed09ef5ad375c4e3c3090f118cda8.svg";
export { ForwardRef as ReactComponent };